const SET_LOADER = "SET_LOADER";
const SET_FILTERS = "SET_FILTERS";
const SET_ALL_SCHOOLS = 'SET_ALL_SCHOOLS';

export { SET_LOADER, SET_FILTERS, SET_ALL_SCHOOLS };
